/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Auth_TitleInputs */

const en_directory_api_reference_auth_title = /** @type {(inputs: Directory_Api_Reference_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization flow`)
};

const zh_directory_api_reference_auth_title = /** @type {(inputs: Directory_Api_Reference_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权流程`)
};

/**
* | output |
* | --- |
* | "Authorization flow" |
*
* @param {Directory_Api_Reference_Auth_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_auth_title = /** @type {((inputs?: Directory_Api_Reference_Auth_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Auth_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_auth_title(inputs)
	return zh_directory_api_reference_auth_title(inputs)
});
export { directory_api_reference_auth_title as "directory.api_reference.auth_title" }